import toLocalDate from './toLocalDate';

/*
  For now, just call through to toLocalDate
  Eventually we may need to make this work with a firm timezone
*/
export default toLocalDate;
